/** "Windows · Chrome" style summary — enough to spot device patterns without reading full UAs.
 *  Shared by the admin dashboards (Client Errors, Quiz Responses). */
export function deviceLabel(ua?: string | null): string {
    if (!ua) return '—';
    const os = /Android/i.test(ua) ? 'Android' : /iPhone|iPad|iOS/i.test(ua) ? 'iOS'
        : /Windows/i.test(ua) ? 'Windows' : /Mac OS/i.test(ua) ? 'macOS' : /Linux/i.test(ua) ? 'Linux' : '?';
    const browser = /Edg\//.test(ua) ? 'Edge' : /Chrome\//.test(ua) ? 'Chrome'
        : /Safari\//.test(ua) && !/Chrome/.test(ua) ? 'Safari' : /Firefox\//.test(ua) ? 'Firefox' : '?';
    return `${os} · ${browser}`;
}
